exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ndiv.active-promotion[data-v-0d8be594] {\n  width: 72px;\n  height: 32px;\n  border-radius: 4px;\n  background-color: #0a43a7;\n  padding: 2px 10px 0 10px;\n}\ntable.v-table tbody td[data-v-0d8be594],\ntable.v-table tbody th[data-v-0d8be594] {\n  height: 60px;\n}\n", ""]);

